'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('./Icon.scss');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var id = _ref.id,
      children = _ref.children,
      viewBox = _ref.viewBox,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height;
  return _react2.default.createElement(
    'svg',
    {
      id: id,
      className: _Icon2.default.iconDefault,
      width: width || size,
      height: height || size,
      viewBox: viewBox
    },
    children
  );
};

Icon.defaultProps = {
  size: '1em'
};

Icon.propTypes = {
  id: _propTypes2.default.string,
  size: _propTypes2.default.string,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  children: _propTypes2.default.any,
  viewBox: _propTypes2.default.string.isRequired
};

exports.default = Icon;
//# sourceMappingURL=Icon.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/Icon.js